// extracted by mini-css-extract-plugin
export default {"root":"C44EMe","galleryWrapper":"lslQSV","changing_background":"guBhoB","changingBackground":"guBhoB"};